import { createFileRoute } from "@tanstack/react-router";
import { TidsplanlaegningPage, tidsplanlaegningHead } from "@/pages/TidsplanlaegningPage";

export const Route = createFileRoute("/en/scheduling")({
  head: () => tidsplanlaegningHead("en"),
  component: () => <TidsplanlaegningPage locale="en" />,
});
